// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__HeX1T","content":"mimic___style_content__0i1hS"};